// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".markdown[data-v-45a87f61]{position:relative;flex:1 1 0}.markdown iframe[data-v-45a87f61]{position:absolute;width:100%;height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
